import { render } from "./LegalPageSingle.vue?vue&type=template&id=947d8048"
import script from "./LegalPageSingle.vue?vue&type=script&lang=js"
export * from "./LegalPageSingle.vue?vue&type=script&lang=js"

import "./LegalPageSingle.vue?vue&type=style&index=0&id=947d8048&lang=scss"

import exportComponent from "/var/www/prod.storm.ms/actions-runner/storm-site/storm-site/storm-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__